/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectRole } from './ProjectRole';
import {
    ProjectRoleFromJSON,
    ProjectRoleFromJSONTyped,
    ProjectRoleToJSON,
    ProjectRoleToJSONTyped,
} from './ProjectRole';

/**
 * 
 * @export
 * @interface ProjectRoleOutput
 */
export interface ProjectRoleOutput {
    /**
     * 
     * @type {ProjectRole}
     * @memberof ProjectRoleOutput
     */
    projectRole?: ProjectRole;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectRoleOutput
     */
    channels?: Array<string>;
}

/**
 * Check if a given object implements the ProjectRoleOutput interface.
 */
export function instanceOfProjectRoleOutput(value: object): value is ProjectRoleOutput {
    return true;
}

export function ProjectRoleOutputFromJSON(json: any): ProjectRoleOutput {
    return ProjectRoleOutputFromJSONTyped(json, false);
}

export function ProjectRoleOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectRoleOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'projectRole': json['projectRole'] == null ? undefined : ProjectRoleFromJSON(json['projectRole']),
        'channels': json['channels'] == null ? undefined : json['channels'],
    };
}

export function ProjectRoleOutputToJSON(json: any): ProjectRoleOutput {
    return ProjectRoleOutputToJSONTyped(json, false);
}

export function ProjectRoleOutputToJSONTyped(value?: ProjectRoleOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectRole': ProjectRoleToJSON(value['projectRole']),
        'channels': value['channels'],
    };
}

